<template>
  <v-card class="ma-0 pa-0 d-block">
    <div>
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="series"
        height="400"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
/**
 * ColumnChart
 * @description Apex bar chart
 *
 */

export default {
  name: "ReportsColumnStackedChart",
  props: {
    /**
     * @type {{name: string,type: string,dateLabel: string, title: string,values: {categories: [],series: [],colors: []}}}
     */
    chart: {
      required: true,
      type: Object,
    },
  },
  computed: {
    chartOptions: function () {
      return {
        chart: {
          type: "bar",
          height: "400",
          stacked: true,
          stackType: "100%",
        },
        colors: this.chart.values.colors
          ? this.chart.values.colors
          : ["#7e04b7"],
        plotOptions: {
          bar: {
            columnWidth: "80%",
            horizontal: false,
            distributed: false,
            borderRadius: 8,
            dataLabels: {
              position: "center", // top, center, bottom
            },
          },
        },
        fill: {
          opacity: 1,
        },
        yaxis: [
          {
            title: {
              text: "Fulfilled order count",
            },
            min: 0,
          },
        ],
        legend: {
          show: false,
        },
        xaxis: {
          categories: this.chart.values.categories,
          tickPlacement: "on",
          labels: {
            rotate: 0,
            style: {
              // colors: this.serverData.values.color1,
              fontSize: "8px",
            },
          },
        },
      };
    },
    series: function () {
      return this.chart.values.series;
    },
  },
};
</script>
